// AUTO-GENERATED SEED — review before trusting. Rename keys (index→list/detail),
// refine params, confirm caller flags, add opt-in response types.
import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
// Type-only import (erased at build) — keeps the registry client-bundle-safe.
import type { NativeAuthExchangeDto } from '../../schemas/responses/native-auth-exchange';
import type { SocialProvidersResponse } from '../../schemas/responses/social-providers';

const BETTER_AUTH_GRANT = { none: 'pre-auth — Better Auth authenticates the request itself' } as const;
const STAFF_IDENTITY = { from: 'none', reason: 'pre-auth — staff identity is global, not per tenant' } as const;

export const auth = {
  // Better Auth staff catch-all (BL-786). caller:'external' — hit directly by
  // the browser's Better Auth client, not the typed api.* client. Declared, not
  // bound (BL-1833 PR 4a): sign-in runs here before any session exists.
  all: defineAdminRoute({
      path: '/api/auth/:all*',
      params: { all: '' },
      methods: {
        GET: { grant: BETTER_AUTH_GRANT, tenant: STAFF_IDENTITY },
        POST: { grant: BETTER_AUTH_GRANT, tenant: STAFF_IDENTITY },
      },
      caller: 'external',
    }),
  // BL-788: change-password migrated to the Better Auth client
  // (authClient.changePassword → /api/auth/change-password via the catch-all).
  // Declared, not bound (BL-1833 PR 4a): its 401 body `{ success: false,
  // user: null }` is what the 401-redirect re-check reads, and the gate's 401
  // would replace it.
  // BL-2065: the native app's Google sign-in ends in the phone's browser sheet
  // with a one-use token; this trades it for the session cookie inside the app.
  // Pre-auth by nature — the token IS the credential — so it declares `none`
  // and is not bound to the ADR 062 gate, which would 401 it. Called in-app
  // through the typed client by `startSocialSignIn` (BL-2090).
  native: {
    exchange: defineAdminRoute({
        path: '/api/auth/native/exchange',
        params: {},
        methods: {
          POST: {
            grant: { none: 'token — the one-time native sign-in token authorizes it' },
            tenant: STAFF_IDENTITY,
            response: responseType<NativeAuthExchangeDto>(),
          },
        },
      }),
  },
  // BL-2776: which social sign-in providers are configured, so the signed-out
  // sign-in screens show a button only for a provider that can work. Pre-auth by
  // nature (no session exists yet) and carries no tenant data.
  socialProviders: defineAdminRoute({
      path: '/api/auth/social-providers',
      params: {},
      methods: {
        GET: {
          grant: { none: 'pre-auth — provider availability, the same answer for every caller' },
          tenant: STAFF_IDENTITY,
          response: responseType<SocialProvidersResponse>(),
        },
      },
    }),
  me: defineAdminRoute({
      path: '/api/auth/me',
      params: {},
      methods: {
        GET: {
          grant: { none: "self — the caller's own session" },
          tenant: { from: 'none', reason: 'self — a staff session spans tenants' },
        },
      },
    }),
};
